import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import VueResource from "vue-resource";
import VueSvgGauge from "vue-svg-gauge";
import VueQrcodeReader from "vue-qrcode-reader";
import VueResize from "vue-resize";
import Vuelidate from "vuelidate";
import VueApexCharts from "vue-apexcharts";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

/* import VueMoment from "vue-moment"; */

import { router } from "./router";
import { store } from "./store";

import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";

import "vue-resize/dist/vue-resize.css";
import "leaflet/dist/leaflet.css";

Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.use(VueSvgGauge);
Vue.use(VueQrcodeReader);
Vue.use(VueResize);
Vue.use(Vuelidate);
Vue.use(VueApexCharts);

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);

/* Vue.use(VueMoment); */

router.beforeEach((to, from, next) => {
  let language = to.params.lang;
  if (!language) {
    language = "en";
  }
  i18n.locale = language;
  next();
});

new Vue({
  vuetify,
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
